

import { useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, FormikHelpers, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import { Box, Button, Dialog, FormControl, InputLabel, List, ListItem, ListItemText, MenuItem, Select, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Pagination from '@mui/material/Pagination';
import { CustomTextField, CustomSelect } from '../../Components'
import { useAddMarkMutation, useDeleteMarkMutation, useGetMarkQuery, useGetModelQuery } from '../../store/services/markmodel';
import { IMark } from '../../types';
import DeleteModal from '../../Components/DeleteModal';


function Model() {
  const [open, setOpen] = useState<boolean>(false);
  const [model, setModel] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [deletedItem, setDeletedItem] = useState<number | null>(null);
  const { data: marks, } = useGetMarkQuery({ limit: 10, offset: (page - 1) * 10, modelId: model });
  const { data: models } = useGetModelQuery({ limit: 1000000, offset: 0 });
  const [deleteMark] = useDeleteMarkMutation({});
  const [addMark, { error }] = useAddMarkMutation();
  const errorToast = (err: any) => toast.error(err ? err.error : 'someting went wrong');

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleSelectModel = useCallback((id: number) => {
    setModel(id)
  }, [])

  const handleOpenDeleteModal = useCallback((id: number) => {
    setDeletedItem(id)
  }, [])

  const handleCloseDeleteModal = useCallback(() => {
    setDeletedItem(null)
  }, [])

  const deleteFunction = useCallback(() => {
    deleteMark({ id: deletedItem })
    handleCloseDeleteModal()
  }, [deletedItem])

  const handleChange = useCallback((event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  }, []);

  useEffect(() => {
    if (error) {
      errorToast(error);
    }
  }, [error])

  interface Values {
    mark?: number;
    name: string
  }

  const SignupSchema = Yup.object().shape({
    modelId: Yup.number()
      .required(t('required')),
    name: Yup.string()
      .required(t('required')),
  });

  return <Box sx={{ display: 'flex', flexDirection: 'column' }}>
    <Typography gutterBottom variant="h5" component="div">{t('model')}</Typography>
    <Box sx={{ display: 'flex' }} onClick={() => handleOpen()}>
      <AddIcon />
    </Box>
    <DeleteModal
      deleteFunction={deleteFunction}
      handleClose={handleCloseDeleteModal}
      open={!!deletedItem}
    />
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={open}
      onClose={handleClose}
    >
      <Box sx={{ minWidth: 200, mb: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 4, paddingBottom: 4 }}>
        <Formik
          initialValues={{
            name: '',
            modelId: ''
          }}
          validationSchema={SignupSchema}
          onSubmit={(
            values: Values,
            { setSubmitting }: FormikHelpers<Values>
          ) => {
            addMark(values);
            handleClose()
          }}
        >
          {({ errors, touched }: any) => (
            <Form >
              <Box sx={{ minWidth: 200, mb: 2 }}>
                <FormControl fullWidth>
                  <CustomSelect
                    name='modelId'
                    label={t('mark')}
                    list={models?.result}
                  />
                </FormControl>

              </Box>
              <Box sx={{ minWidth: 200, mb: 2 }}>
                <FormControl >
                  <CustomTextField name='name' label={t('model')} variant="outlined" />
                </FormControl>
              </Box>
              <Button type='submit' variant="contained">{t('create')}</Button>
            </Form>
          )}
        </Formik>

      </Box>
    </Dialog>
    <Box sx={{ minWidth: 120, maxWidth:400, marginTop:'50px', marginBottom:'20px'  }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{t('mark')}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={model}
          label={t('mark')}
          onChange={(e) => handleSelectModel(e?.target?.value)}
        >
          {models?.result.map((model) => <MenuItem value={model.id}>{model?.name}</MenuItem>)}

        </Select>
      </FormControl>
    </Box>
    <List
      sx={{
        width: '100%',
        maxWidth: 360,
        bgcolor: 'background.paper',
        position: 'relative',
        overflow: 'auto',
        height: '100%',
        '& ul': { padding: 0 },
      }}
      subheader={<li />}
    >
      {
        marks?.result.filter((el) => {
          return el?.model_id === model
        })?.map((item: IMark) => (
          <ListItem key={item.id}>
            <ListItemText primary={item.name} />
            <DeleteIcon onClick={() => item.id ? handleOpenDeleteModal(item.id) : console.log('fg')
            } className='cusor-pointer' />
          </ListItem>
        ))
      }
    </List>
    {model && marks?.result[0] && marks?.result[0]?.count > 10 && <Pagination count={Math.ceil(marks?.result[0]?.count / 10)} color="primary" page={page} onChange={handleChange} />}
  </Box>
}
export default Model;